import { Component, Inject } from '@angular/core';
import {
	FormControl,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.services';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-rename-device-group-dialog',
	templateUrl: './rename-device-group-dialog.component.html',
	styleUrls: [
		'./rename-device-group-dialog.component.scss',
		'../../common/main.scss',
	],
	imports: [
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinner,
		MatDialogActions,
	],
})
export class RenameDeviceGroupDialogComponent {
	showMessage = true;
	showError = false;
	loading = false;

	nameInput = new FormControl('', [Validators.required]);

	constructor(
		private readonly apiService: ApiService,
		private dialogRef: MatDialogRef<RenameDeviceGroupDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	onCancelClicked(): void {
		this.dialogRef.close(false);
	}

	onConfirmClicked(): void {
		this.loading = true;

		this.apiService
			.updateDeviceGroupName(
				this.data.deviceGroupData.group.id,
				this.nameInput.value!
			)
			.then((_) => {
				this.dialogRef.close(true);
			})
			.catch((err) => {
				this.loading = false;
				this.showError = true;
			});
	}
}
